import { render, staticRenderFns } from "./AgreementEdit.vue?vue&type=template&id=383713f4&scoped=true"
import script from "./AgreementEdit.vue?vue&type=script&lang=js"
export * from "./AgreementEdit.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/review_edit.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383713f4",
  null
  
)

export default component.exports